//3rd Party Components
import React from 'react';
import { Redirect } from "react-router-dom";
import { useSelector } from 'react-redux';
import { AUcallout } from '@gov.au/callout';
import AUbutton from '@gov.au/buttons';
import MetaTags from 'react-meta-tags';

//Components
import Heading from '../components/CASA/Heading';
import Container from '../components/CASA/Container';

//Actions
import { getSnippetSelector } from '../PortalStore/Selectors/EnvDataSelectors';


export const POIPage = () => {
    const snippetVerify = useSelector(state => getSnippetSelector(state, 'CASA - Verify POI and Personal details'));
    let user = useSelector(state => state.userdetails);
    let loginPath = useSelector(state => state.B2CSettings.items.loginPath);

    if (loginPath == 'myGov' && user.items.value[0].casa_arn) {
        return <Redirect to='/poiverification' />;
    }
    const navigateVerifyPOI = () => {
        const crumbs = [
            {
                link: '/',
                text: 'myCASA'
            },
            {
                link: '/verifypoi',
                text: 'Personal details and identity verification'
            }
        ];
        const params = {
            'formID': 'VERIFYPOI',
            'breadcrumbs': crumbs
        };
        //if (user.participants.hasParticipants) {
        //    params.showProfileSelector = 1;
        //}
        const poiLinkRoute = '/forms/poiverification';
        //const linkpoi = urlAEM + urlVerifyPOI + '?' + encodeURIComponent(btoa(JSON.stringify(params)));

        return poiLinkRoute;
    };

    const poiMsg = () => {
        const msg = { __html: snippetVerify };

        return (<div dangerouslySetInnerHTML={msg}></div>);
    };

        const items = [];
        const showItems = false;

        const link = navigateVerifyPOI();
        return (
            <div>
                <Container show={true}>
                    <MetaTags title='Proof of Identity'></MetaTags>

                    <div className='row'>
                        <div className='col-sm-12'>
                            <Heading
                                text='Personal details and identity verification'
                                breadcrumbs={items}
                                showcrumbs={showItems}
                                showback={false} />
                        </div>
                    </div>

                    <AUcallout title=''>
                        {poiMsg()}
                    </AUcallout>

                    <div>
                        <br />
                        <AUbutton id='btnVerifyPOI' className='au-btn au-btn--darker' link={link}>Begin verification</AUbutton>
                    </div>

                    <br />

                </Container>
            </div>
        );
    
};